export const environment = {
  baseAPI: 'https://securepay-backend-dev.getsecurepay.ai',
  production: false,
  checkoutFrontendUrl:
    'https://securepay-dev-checkout.secureid-digital.com.ng/',
};
